<template lang="pug">
  div(class="bg")
    slider
  
</template>

<script>
// @ is an alias to /src
import ImageRow from "@/components/ImageRow.vue";
import Slider from "@/components/Slider.vue";

export default {
  name: "home",
  components: {
    ImageRow,
    Slider
  }
};
</script>
